var render = function render(){var _vm=this,_c=_vm._self._c;return _c('vm-layer',{attrs:{"source":_vm.source,"type":"raster","name":"satelite","paint":_vm.style.paint,"minzoom":1}})
}
var staticRenderFns = []

export { render, staticRenderFns }